<form #purchaseOrderForm="ngForm" class="col">
    <div class="row">
        <mat-form-field appearance="outline" class="fx-50">
            <mat-label>Purchase order number</mat-label>
			<input matInput 
                [(ngModel)]="purchaseOrder.PurchaseOrderNumber" 
				[ngModelOptions]="{standalone: true}" 
				[required]="!!!purchaseOrder.RequestNumber" 
				[maxlength]="allowMultiple ? 500 : 20"
				[placeholder]="allowMultiple ? 'enter one or more PO numbers, comma-separated' : 'enter PO number'">
			<mat-hint *ngIf="allowMultiple">Separate multiple PO numbers with commas to create several at once.</mat-hint>
		</mat-form-field>

		<mat-form-field appearance="outline" class="fx-50">
            <mat-label>Request number</mat-label>
            <input matInput 
                [(ngModel)]="purchaseOrder.RequestNumber" 
				[ngModelOptions]="{standalone: true}" 
				[required]="!!!purchaseOrder.PurchaseOrderNumber"
				maxlength="10"
                placeholder="enter request number">
		</mat-form-field>
	</div>
	
	<div class="row">
		<app-autocomplete-dropdown class="fx-50"
			[parentFormControl]="purchaseOrderForm.control"
			[options]="fabricators"
			[label]="'Vendor'"
			[displayProperty]="'Name'"
			[defaultValue]="fabricatorDefValue"  
			[placeholder]="'select vendor'"
			[required]="true"
			(selectedChanged)='onFabricatorChanged($event)'
			(clicked)="onLoadFabricators()">
		</app-autocomplete-dropdown>

		<mat-form-field appearance="outline" class="fx-50">
			<mat-label>Submit date</mat-label>
			<input matInput #sdRef 
				[(ngModel)]="purchaseOrder.SubmitDate" 
				[ngModelOptions]="{standalone: true}" 
				[matDatepicker]="submitDatePicker" 
				[required]="!!purchaseOrder.PurchaseOrderNumber" 
				placeholder="supplier FAT date">
			<mat-datepicker-toggle matSuffix
				[for]="submitDatePicker">
			</mat-datepicker-toggle>
			<mat-datepicker #submitDatePicker></mat-datepicker>
		</mat-form-field>
	</div>
</form>
